const EXACT_3D = 'exact_3d';
const CONFIGURED_2D = 'configured_2d';
const UNSUPPORTED = 'unsupported';

const resolveRenderCoverage = (identity, vehicle, findPreset) => {
  if (!identity?.renderModelKey || !identity?.renderLayoutKey) {
    return {
      state: UNSUPPORTED,
      identity,
      reason: 'unmapped_render_identity',
    };
  }

  const preset = typeof findPreset === 'function' ? findPreset(identity, vehicle) : undefined;
  if (!preset) {
    return {
      state: CONFIGURED_2D,
      identity,
      reason: 'no_compatible_preset',
    };
  }

  return {
    state: EXACT_3D,
    identity,
    preset,
    reason: 'compatible_preset',
  };
};

export {
  CONFIGURED_2D,
  EXACT_3D,
  UNSUPPORTED,
  resolveRenderCoverage,
};
